import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationsPausedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notifications_paused"}/>
}
